import React, { useState } from 'react';
import { Anchor } from '@bxp-framework/components';
import { getHeaderTheme } from '../themes';
import { useAnalytics, LogoTrello } from '../../../components';
export function HeaderLogo({ appearance }) {
    const { linkColor, linkColorHover } = getHeaderTheme(appearance);
    const [logoColor, setLogoColor] = useState(linkColor);
    const { sendTrackEvent } = useAnalytics();
    return (React.createElement("div", { onMouseEnter: () => setLogoColor(linkColorHover), onMouseLeave: () => setLogoColor(linkColor) },
        React.createElement(Anchor, { href: "/home", onClick: () => sendTrackEvent('clickedUiHeaderLogo', {
                event: 'clicked',
                eventComponent: 'logo',
                eventContainer: 'uiHeader',
                href: '/home',
                logoColor
            }) },
            React.createElement(LogoTrello, { colorID: logoColor, height: 36 }))));
}
//# sourceMappingURL=HeaderLogo.js.map